import React, { ReactNode } from 'react';
import { Modifier } from '../../../../../../lib/bemUtils/Modifier';
import bem from '../../../../../../lib/bemUtils/bem';

export enum FormsComboboxMultiSelectListModifier {
  MARGIN_TOP = 'margin-top',
}

type FormsComboboxMultiSelectListProps = {
  labelId: string;
  modifier?: Modifier<FormsComboboxMultiSelectListModifier>;
  children: ReactNode[];
};

export function FormsComboboxMultiSelectList({ labelId, modifier, children }: FormsComboboxMultiSelectListProps) {
  return (
    <ul className={bem('forms-combobox-multiselect__list', modifier)} aria-labelledby={labelId}>
      {children}
    </ul>
  );
}
